import React from "react";
// Creating Feature context so any component requiring feature flag data is able to access by using this context
// The feature flag data is updated in routeRender getEnabledFeatures function

export const FeatureContext = React.createContext({
    featureFlags:[],
    setFeatureFlags: (featureFlags)=>{},
    isFeatureEnabled:(featureName)=>{}
});

export function withFeatureFlags(Component){
    return function ComponentWithFeatureFlag(props){
        return (
            <FeatureContext.Consumer>
                { featureFlags => <Component {...props} featureFlags={featureFlags} />}
            </FeatureContext.Consumer>
        )
    }
}